
import { mapActions, mapGetters } from 'vuex'
import store from '@/common/config/store'

export default {
  components: {
    'component-alert': () => import(/* webpackChunkName: "components" */ '@/common/components/Alert.vue'),
    'component-button': () => import(/* webpackChunkName: "components" */ '@/common/components//Button.vue'),
  },

  data: () => ({
    store,
    beneficiaries_list: {
      id: null,
      label: '',
      comment: '',
      list_type: {
        id: null,
        name: null,
      },
    },
    selectedType: null,
    types: [],
    formSubmited: false,
  }),

  computed: {
    ...mapGetters([
      'beneficiaryLists',
      'beneficiaryListTypes'
    ]),
    isNewType () {
      return this.beneficiaries_list.list_type.is_new === true
    },
    
    isExistingList () {
      return store.modal.dataModel.id
    },

    title () {
      return this.isExistingList ? this.$i18n.t('modal.beneficiaries_list.edit') : this.$i18n.t('modal.beneficiaries_list.new')
    }
  },

  watch: {
    selectedType (newValue) {
      if (newValue) {
        this.beneficiaries_list.list_type = JSON.parse(newValue)
      }
    },
  },

  mounted () {
    this.types = [ ...this.beneficiaryListTypes ]
    this.types.push({
      id: null,
      name: null,
      label: this.$i18n.t('form.beneficiaries_list.type.new'),
      is_new: true,
    })
    
    if (this.isExistingList) {
      Object.assign(this.beneficiaries_list, this.beneficiaryLists.find(list => list.id === store.modal.dataModel.id))
    } else {
      this.beneficiaries_list.list_type = this.types[0]
    }

    this.selectedType = JSON.stringify(this.beneficiaries_list.list_type)
  },

  methods: {
    ...mapActions([
      'createBeneficiariesList',
      'editBeneficiariesList'
    ]),
    
    /**
     * onSubmit
     * @param e
     */
    onSubmit () {
      this.formSubmited = true
      this.$validator.validateAll().then(result => {
        if (result) {
          const beneficiariesList = { ...this.beneficiaries_list }
          beneficiariesList.list_type = {
            id: beneficiariesList.list_type.id,
            name: beneficiariesList.list_type.name,
          }
          if (this.isExistingList) {
            this.editBeneficiariesList(beneficiariesList).then(() => {
              this.showBanner('success', this.$i18n.t('banner.success.beneficiary_list.edit'))
              this.close()
            })
          } else {
            this.createBeneficiariesList(beneficiariesList).then(() => {
              this.showBanner('success', this.$i18n.t('banner.success.beneficiary_list.create'))
              this.close()
            })
          }
        } else {
          this.$bus.$emit('scrollToTop')
        }
      })
    },
    
    close () {
      store.modal.active = false
    }
  },
}
